import { useEffect, useState } from 'react'

const PREFIXO = 'faturamento.estado.'

function ler(key, inicial) {
  try {
    const salvo = sessionStorage.getItem(PREFIXO + key)
    return salvo === null ? inicial : JSON.parse(salvo)
  } catch {
    return inicial
  }
}

/**
 * useState que sobrevive à navegação dentro da aba (sessionStorage).
 * Usado nos filtros/ordenação das listagens: ao voltar do detalhe
 * (`/nf/:id`, `/contrato/:id`) a listagem reabre como estava.
 */
export function useSessionState(key, inicial) {
  const [valor, setValor] = useState(() => ler(key, inicial))

  useEffect(() => {
    try {
      sessionStorage.setItem(PREFIXO + key, JSON.stringify(valor))
    } catch {
      /* sessionStorage indisponível — mantém só em memória. */
    }
  }, [key, valor])

  return [valor, setValor]
}

/** Esquece todos os estados salvos (ex.: no logout). */
export function limparSessionState() {
  try {
    const chaves = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i)
      if (k?.startsWith(PREFIXO)) chaves.push(k)
    }
    chaves.forEach((k) => sessionStorage.removeItem(k))
  } catch {
    /* sessionStorage indisponível — nada a limpar. */
  }
}
